import React from 'react';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { useSidebarContext } from './SidebarContext';
import { useTheme } from '../../../contexts/ThemeContext';
import { getThemedStyles } from './styles';

/**
 * 侧边栏头部组件
 * 包含 Logo 和折叠按钮
 */
const SidebarHeader = () => {
  const { collapsed, toggleCollapsed } = useSidebarContext();
  const { isDark } = useTheme();
  const themedStyles = getThemedStyles(isDark);
  
  // 折叠状态下居中显示按钮
  const containerStyle = collapsed 
    ? { ...themedStyles.headerStyle, justifyContent: 'center' }
    : themedStyles.headerStyle;
  
  return (
    <div style={containerStyle}>
      {!collapsed && (
        <span style={themedStyles.logoStyle}>YQ Admin</span>
      )}
      <span
        style={themedStyles.collapseButtonStyle}
        onClick={toggleCollapsed}
        onKeyDown={(e) => e.key === 'Enter' && toggleCollapsed()}
        role="button"
        tabIndex={0}
        aria-label={collapsed ? '展开侧边栏' : '折叠侧边栏'}
      >
        {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
      </span>
    </div>
  );
};

export default SidebarHeader;
